import styled from "@emotion/styled";

const Spacer = styled.div`
  height: ${({ rem = 3 }) => rem}rem;
`;

export default Spacer;

export const ColSpacer = styled.div`
  width: ${({ rem = 3 }) => rem}rem;
  min-width: 1rem;
`;
